import { useCallback } from 'react';
import { usePartnerDataClient } from '../api/use-partner-data-client';
import { ValidationReport } from '../domain/types';
import { useAsyncResource } from './use-async-resource';

export interface UseIngestionValidationReturn {
  /** `null` while PDGS has no report for this ingestion yet. */
  validation: ValidationReport | null;
  isLoading: boolean;
  hasError: boolean;
  refetch: () => void;
}

/**
 * The validation report for an ingestion.
 *
 * Deliberately not polled: PDGS writes the report once and never updates it,
 * so a report that exists is final and one that does not yet exist appears
 * when the operator revisits the tab.
 */
export const useIngestionValidation = (
  eventId: string,
): UseIngestionValidationReturn => {
  const client = usePartnerDataClient();

  const fetchValidation = useCallback(
    () => client.getValidation(eventId),
    [client, eventId],
  );

  const { data, isLoading, hasError, refetch } =
    useAsyncResource<ValidationReport | null>(fetchValidation, null);

  return { validation: data, isLoading, hasError, refetch };
};
